import cn from 'classnames';
import * as React from 'react';

import { ScoreIcon, ScoreIconStyle } from 'fable/ScoreIcon';

import styles from './index.module.scss';

interface Props {
  className?: string;
  question: string;
  ratingStyle: CSATRatingStyle;
}

export type CSATRatingStyle = ScoreIconStyle;

export const RatingPreview: React.FunctionComponent<Props> = ({
  ratingStyle,
  question,
  className,
}) => {
  const ratingScores = [1, 2, 3, 4, 5] as const;

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.question} dir="auto">
        {question}
      </div>
      <div className={styles.ratingScale}>
        <div className={styles.ratingScaleWrapper}>
          {ratingScores.map((score) => (
            <ScoreIcon
              score={score}
              style={ratingStyle}
              key={`${ratingStyle}-${score}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
